// @core/api/endpoints/chat/send_typing_indicator.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendTypingIndicatorRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Send typing indicator
 * Broadcasts a typing indicator to other conversation members. Prefer WS for real-time typing.
 */
export async function SendTypingIndicator(
  conversation_id: string,
  data: SendTypingIndicatorRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/typing`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
